<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="FM-Epigraph-verse-fmepiv">Calm as that second summer which precedes</p>
<p class="FM-Epigraph-verse-fmepiv">The first fall of the snow,</p>
<p class="FM-Epigraph-verse-fmepiv">In the broad sunlight of heroic deeds,</p>
<p class="FM-Epigraph-verse-fmepiv">The City bides the foe.</p>
<p class="FM-Epigraph-Source-fmeps"><span class="ePub-B">—Henry Timrod, “Charleston”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?d8951324